var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.detail.auditState == 2 || _vm.detail.auditStatus == 2)?_c('div',{staticClass:"audit-detail"},[_c('i',{staticClass:"el-icon-warning"}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.errorText)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }